import {Api,handleResponse,handleError} from '../../../../../../api';
//Action
const Actions = {
    Edit: 'inner/edit-tender',
}


export const apiRequest = {
    edit
};

async function edit(parent,data) {
    const {onRefresh} = parent.props;
    await new Api().call.post(Actions.Edit,data).then(handleResponse)
        .then(res => {
            parent.setState({
                response:res,
                editedTender:res.data,
                loading:false
            });     
            onRefresh(res.data);
        }).catch(error=>{
            let validResponse = {message:'Váratlan hiba történt',type:'error'};
            if(error!=null && error!==undefined && error.response!==null && error.response!==undefined){
                validResponse = error.response.data;
            }
            parent.setState({
                response:validResponse,
                loading:false
            });
            handleError(error);
        });
}